// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyMessage_container__2yzxE","message":"EmptyMessage_message__5R3g2"};